import { Buffer } from 'buffer';
// const customers = 'CustDetails?$filter=No%20eq%20%27NAV/004%27';
const BackendUname =process.env.REACT_APP_API_USERNAME;
const BackendPwd =process.env.REACT_APP_API_PASSWORD;
const ReactDataUrl = process.env.REACT_APP_API_DATA_URL;
const ReactCompany = process.env.REACT_APP_COMPANY;
export const base64backendtoken = Buffer.from(`${BackendUname}:${BackendPwd}`, 'utf8').toString('base64');


export const bidLines = ReactDataUrl + 'bidlines?'+ ReactCompany;
export const bidHeader = ReactDataUrl + 'bidheader?'+ ReactCompany;